import type { FC } from 'react';
import React from 'react';
import { Helmet } from 'react-helmet';

import type { IProps } from './models';

export const LinkCanonical: FC<IProps> = ({ url }) => (
    <Helmet>
        <link href={url} rel="canonical" />
    </Helmet>
);
